module.exports = __webpack_public_path__ + "img/no-order.be0a8070.png";